var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoDisable = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19.998,
    viewBox: "0 0 20 19.998",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico_disable",
    d: "M365.18,629.351h0a10,10,0,1,0,9.966,10.034v-.034A9.979,9.979,0,0,0,365.18,629.351Zm4.481,11.576h-8.543a1.349,1.349,0,0,1,0-2.7h8.543a1.349,1.349,0,1,1,0,2.7Z",
    transform: "translate(-355.142 -629.351)",
    fill: "#999"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoDisable);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_disable.58258f9a50d32c502cf0affcd1e77751.svg";